/**
 * Completely disable React/Webpack error overlays in development
 * This addresses the persistent "Script error" overlay issue
 */

// 1. Suppress the error overlay from react-error-overlay
if (typeof window !== 'undefined') {
  // Prevent react-error-overlay from initializing
  const originalError = console.error;
  console.error = (...args) => {
    // Don't suppress actual errors from console, just prevent overlay
    if (args[0] && typeof args[0] === 'string' && 
        (args[0].includes('ResizeObserver') || 
         args[0].includes('Script error') ||
         args[0].includes('cross-origin'))) {
      return; // Suppress these harmless errors
    }
    originalError.apply(console, args);
  };

  // 2. Override window.onerror to catch "Script error" and prevent overlay
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    // "Script error" comes from cross-origin scripts - suppress overlay
    if (message === 'Script error.' || message === 'Script error') {
      return true; // Prevent default handling (overlay)
    }
    // For other errors, call original handler if exists
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // 3. CSS to hide any overlays that might still appear
  const disableReactErrorOverlay = () => {
    const style = document.createElement('style');
    style.id = 'disable-error-overlay';
    style.innerHTML = `
      /* Hide all error overlay iframes */
      iframe#webpack-dev-server-client-overlay,
      iframe[id*="webpack"],
      iframe[src*="webpack"],
      div#webpack-dev-server-client-overlay-div,
      #webpack-dev-server-client-overlay,
      /* React Error Overlay specific */
      div[style*="position: fixed"][style*="z-index: 2147483647"],
      body > iframe[style*="position: fixed"][style*="z-index"],
      /* Generic overlay pattern */
      body > div[style*="position: fixed"][style*="inset: 0"],
      body > div[style*="position: fixed"][style*="background: rgba"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        width: 0 !important;
        height: 0 !important;
      }
    `;
    
    if (!document.getElementById('disable-error-overlay')) {
      document.head.appendChild(style);
    }

    // Remove any existing overlays
    const removeOverlay = () => {
      const selectors = [
        'iframe#webpack-dev-server-client-overlay',
        'iframe[id*="webpack"]',
        'iframe[src*="webpack"]',
        '#webpack-dev-server-client-overlay-div',
        'body > iframe[style*="position: fixed"]'
      ];
      
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.display = 'none';
          el.remove();
        });
      });
      
      // Also check for divs that look like error overlays
      document.querySelectorAll('body > div').forEach(div => {
        const style = div.getAttribute('style') || '';
        if (style.includes('position: fixed') && 
            style.includes('z-index') && 
            (style.includes('inset: 0') || style.includes('2147483647'))) {
          div.remove();
        }
      });
    };

    removeOverlay();
    
    // Watch for new overlays being added
    const observer = new MutationObserver((mutations) => {
      let shouldRemove = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) { // Element node
            const tagName = node.tagName?.toLowerCase();
            const id = node.id || '';
            const style = node.getAttribute?.('style') || '';
            
            if (tagName === 'iframe' || 
                id.includes('webpack') ||
                (style.includes('position: fixed') && style.includes('z-index'))) {
              shouldRemove = true;
              break;
            }
          }
        }
      }
      if (shouldRemove) {
        removeOverlay();
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: false });
  };

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableReactErrorOverlay);
  } else {
    disableReactErrorOverlay();
  }
}
